/**
 * Created by fers on 27/08/2017.
 */

import React from 'react';
import PropTypes from 'prop-types';
import './Expression.scss';

interface ExpressionGroupProps {
    children?: any;
    possibleFunctions?: (...args: unknown[]) => unknown;
    possibleVariableGroups?: (...args: unknown[]) => unknown;
    possibleVariables?: (...args: unknown[]) => unknown;
}

export default class ExpressionGroup extends React.Component<ExpressionGroupProps> {

    static propTypes = {
        children: PropTypes.any,
        possibleFunctions: PropTypes.func,
        possibleVariableGroups: PropTypes.func,
        possibleVariables: PropTypes.func,
    };

    static defaultProps = {
        allowEditing: true,
    };

    static childContextTypes = {
        expressionGroup: PropTypes.object,
    };

    constructor(props) {
        super(props);
    }

    getChildContext() {
        return {expressionGroup: this};
    }

    render() {
        return (
            <div className="row">
                <div className="col-sm-6">
                    {this.props.children}
                </div>
                <div className="col-sm-6">
                    {this.props.possibleVariableGroups().map((group, idx) => {
                        return (
                            <div key={idx}>
                                <h3>{group.name}</h3>
                                <table className="table">
                                    <tbody>
                                        {this.props.possibleVariables(group).map((fieldDef, idx) => {
                                            return (
                                                <tr key={idx}>
                                                    <td>{fieldDef.name}</td>
                                                    <td><code>{fieldDef.entityDef.key}@{fieldDef.key}</code><br/> {"${"}{fieldDef.realId}{"}"}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}
